import { RouterService } from './../router.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { SocialAuthService, SocialUser } from 'angularx-social-login';
import { FacebookLoginProvider, GoogleLoginProvider } from 'angularx-social-login';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { CookieService } from 'ngx-cookie-service';
import { CheckUidService } from '../check-uid.service';
import { AppComponent } from '../app.component';
import { SendMessageService } from '../send-message.service';

@Component({
  selector: 'app-register-screen',
  templateUrl: './register-screen.component.html',
  styleUrls: ['./register-screen.component.scss']
})

export class RegisterScreenComponent implements OnInit {
  uid: string;
  id: string;
  user: SocialUser;
  loggedIn: boolean;
  isLogIn: boolean;
  registerState: number;
  app: string;
  client: string;
  constructor(private authService: SocialAuthService, private matIconRegistry: MatIconRegistry, private domSanitizer: DomSanitizer,
              private cookieService: CookieService, private checkUidService: CheckUidService, private appComponent: AppComponent,
              private sendMessage: SendMessageService, private activatedRoute: ActivatedRoute, private router: Router, private routerService: RouterService ) {
      this.matIconRegistry.addSvgIconInNamespace(
        'facebook-svg',
        'facebook',
        this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/facebook.svg'));
      this.matIconRegistry.addSvgIconInNamespace(
        'google-svg',
        'google',
        this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/google.svg'));
     }

  ngOnInit(): void {
    this.activatedRoute.queryParamMap.subscribe(params => {
      if (params.get('app')) {
        this.app = params.get('app');
        this.appComponent.client.subscribe('app_login/' + this.app + '/send');
      }
      if (params.get('client')) {
        this.client = params.get('client');
        this.appComponent.app = this.client;
      }
    });
    this.registerState = 0;
    this.isLogIn = false;
    this.authService.authState.subscribe((user) => {
      this.user = user;
      this.uid = user.id;
      this.cookieService.set('uid', this.uid);
      let message = JSON.stringify({uid: this.uid});
      this.appComponent.client.subscribe('get_id/' + this.uid + '/res');
      this.sendMessage.sendMessage(this.appComponent.client, message, 'get_id/send');
    });
    this.checkUidService.checkStateChange.subscribe((checkState) => {
      if (checkState === 1) {
        this.registerState = 2;
      }
    });
    if (this.cookieService.check('id') && !this.client) {
      this.activatedRoute.fragment.subscribe((fragment: string) => {
        let params: string[] = [];
        console.log(fragment);
        if (fragment) {
          fragment.split('&').forEach(element => {
            params[element.split('=')[0]] = element.split('=')[1]
          });
          if (params['access_token']) {
            this.cookieService.delete('access_token')
            this.cookieService.set('access_token', params['access_token']);
            console.log(this.cookieService.get('access_token'));
            this.router.navigate(['/lottery/' + this.cookieService.get('id')]);
          }
        } else {
          this.router.navigate(['/setting/' + this.cookieService.get('id')]);
        }
      })
    }
  }

  submit(): void {
    if (!/^[a-zA-Z0-9]+$/.test(this.id) || this.id.length === 0) {
      alert('id 只可以包含英文字母及數字');
    } else {
      const message = JSON.stringify({uid: this.uid, id: this.id});
      this.cookieService.set('id', this.id, 999999, '/');
      this.appComponent.client.subscribe('verify/' + this.id + '/res');
      this.sendMessage.sendMessage(this.appComponent.client, message, 'register/send');
    }
  }

  signInWithGoogle(): void {
    this.authService.signIn(GoogleLoginProvider.PROVIDER_ID);
  }

  signInWithFB(): void {
    this.authService.signIn(FacebookLoginProvider.PROVIDER_ID);
  }

  signOut(): void {
    this.authService.signOut();
    this.routerService.GoToHomePage();
  }

  logIn(): void {
    window.open('https://' + window.location.host + '?client=' + this.app , '_blank');
  }
}
